import * as Sentry from '@sentry/react';
import Config from './Config';

export default function initSentry() {
  const sentryConf = Config.getConfig().sentry;

  let config: Sentry.BrowserOptions = {
    normalizeDepth: 20,
    dsn: sentryConf.dsn,
    environment: sentryConf.environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false
      }),
      Sentry.extraErrorDataIntegration({
        depth: 20
      })
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0 //  Capture 100% of the transactions
  };

  if (sentryConf.sessionReplay) {
    config = {
      ...config,
      // Session Replay
      replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    };
  }

  Sentry.init(config);
}
